import React, { useEffect, useState } from 'react'
import DataGrid from 'react-data-grid'
import { getFormsCompleted } from '../api'
import { formatDate } from '../../../resources/empresources/utils/index'
import { FormCompleted } from './types'
import './index.css'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { downloadUploadedForm } from '../../../forms/api'
import { normalizeLink } from '../../../resources/empresources/utils/index'

const Formscompleted: React.FC<{
    otherUserId: string | null
    isActive: boolean
}> = ({ otherUserId, isActive }) => {
    const dispatch = useAppDispatch()
    const [rows, setRows] = useState<FormCompleted[]>([])
    const { id } = useAppSelector((state) => state.persistedReducers.user)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const param = {
                    userId: otherUserId,
                }
                dispatch(SHOW_LOADER())
                const response = await getFormsCompleted(param)
                const data = response.data.map((item: any) => ({
                    name: item.title,
                    completed: item.completedOn
                        ? formatDate(item.completedOn)
                        : '',
                    status: item.status,
                    formId: item.formId,
                }))
                setRows(data)
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        if (isActive) {
            fetchData()
        }
    }, [otherUserId, isActive])

    const downlaodUploadedForms = async (id: string | null, formId: string) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await downloadUploadedForm(id, formId)
            let resourceLink = response?.data
            resourceLink = resourceLink?.replace(/\\/g, '/')
            if (resourceLink) {
                resourceLink = normalizeLink(resourceLink)
            }
            window.open(resourceLink, '_blank')
        } catch (error) {
            console.error('Error downloading form:', error)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    const columns = [
        {
            key: 'name',
            name: 'Name',
            resizable: true,
            sortable: true,
            frozen: true,
        },
        {
            key: 'completed',
            name: 'Completed On',
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: 'Status',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Completed' ? 'comp' : 'status'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'view',
            name: 'View',
            resizable: true,
            sortable: true,
            renderCell: (props: any) =>
                props.row.status === 'Completed' ? (
                    <div className="custom-btn-view">
                        <button
                            className="button button-primary"
                            type="button"
                            onClick={() =>
                                downlaodUploadedForms(
                                    otherUserId ? otherUserId : id,
                                    props.row.formId
                                )
                            }
                        >
                            View
                        </button>
                    </div>
                ) : null,
        },
    ]

    return (
        <div className="table-wrapper grid-table-timeoff mt-4">
            {rows.length === 0 ? (
                <div className="no-records">No records found</div>
            ) : (
                <DataGrid
                    className="data-grid-table"
                    columns={columns}
                    rows={rows}
                    rowHeight={60}
                    headerRowHeight={40}
                />
            )}
        </div>
    )
}

export default Formscompleted
